import React from "react";
import { formatDate } from "Utils";
import { Table } from "antd";

export default function AuthorizationsTable({
  data,
  IsAuthorized,
  loading,
  ...props
}) {
  const columns = [
    {
      title: "Ad",
      dataIndex: "name",
    },
  ];

  return (
    <Table
      style={{ margin: "0 24px" }}
      rowKey={(row) => row.id}
      loading={loading}
      dataSource={data}
      columns={columns}
      locale={{
        filterConfirm: "Filtrele",
        filterReset: "Temizle",
        emptyText: IsAuthorized
          ? "Kayıt Bulunamadı"
          : "Bu işlem için yetkiniz yok. Sistem yöneticiniz ile iletişime geçebilirsiniz.",
      }}
      size="small"
      bordered
      showSorterTooltip={false}
      scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
    />
  );
}
